module.exports = __webpack_public_path__ + "4daefa451cf55f243102e57c40165b1b.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-320.webp
// module id = 361
// module chunks = 0